module.exports = __webpack_public_path__ + "static/media/Eyes_amber.e8ce2424.svg";